import { render } from "./Quotations.vue?vue&type=template&id=b3111760&scoped=true"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"

import "./Quotations.vue?vue&type=style&index=0&id=b3111760&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3111760"]])

export default __exports__